import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { GroupementParc } from '../entities/groupement-parc.entity';

import { EditGroupementDialogComponent } from './edit-groupement-dialog.component';

import { GroupementParcService } from '../services/groupement-parc.service';

@Component({
	selector: 'gestion-groupements-parcs',
	templateUrl: 'gestion-groupements-parcs.html',
	styleUrls: ['gestion-groupements-parcs.css']
})
export class GestionGroupementsParcsComponent implements AfterViewInit {
	
	isLoading: boolean = true;
	data: GroupementParc[] = [];
	dataSource: MatTableDataSource<GroupementParc> = new MatTableDataSource(this.data);
	displayedColumns: string[] = ['antenneNom', 'code', 'libelle', 'parcs', 'actions'];

	// Elements injectes necessaires a la gestion du tableau
	@ViewChild(MatPaginator) paginator!: MatPaginator;
	@ViewChild(MatSort) sort!: MatSort;
	
	// Lien vers la popup d'edition de gp
	@ViewChild(EditGroupementDialogComponent) editPopup!: EditGroupementDialogComponent;
	
	constructor(@Inject(GroupementParcService) private gpService: GroupementParcService) {
		
	}

	ngAfterViewInit() {
		// Initialisation du dataSource
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
		this.reloadGroupementParcs();
	}
	
	onGroupementParcCreationRequest() {
		console.log('onGroupementParcCreationRequest');
		this.editPopup.openForCreation();
	}
	
	onGroupementParcExportRequest() {
		this.gpService.export().subscribe(
			(blob: Blob) => {
  				const fileName: string = 'groupement-parcs.xls';
				const objectUrl: string = URL.createObjectURL(blob);
				const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
				
				a.href = objectUrl;
				a.download = fileName;
				document.body.appendChild(a);
				a.click();        
				
				document.body.removeChild(a);
				URL.revokeObjectURL(objectUrl);
  			},
			(err: any) => {
    			console.log('Could not generate the file, error: ', err);
			}
		);
	}
	
	onGroupementParcModificationRequest(gp: GroupementParc) {
		console.log('onGroupementParcModificationRequest');
		this.editPopup.openForUpdate(gp);
	}
	
	onGroupementParcSuppressionRequest(gp: GroupementParc) {
		console.log('onGroupementParcSuppressionRequest');
		if (confirm('Voulez-vous confirmer la suppression du groupement ' + gp.code + ' ?')) {
			this.gpService.delete(gp.id)
				.pipe(
					catchError(
						(err: any, _caught: Observable<any>) => {
							alert("Erreur lors de la suppression du groupement (Erreur " + err.status + ")");
							return of("error");
						}
					)
				).subscribe(
					(result: any) => {
						if (result != "Error") {
							// rafraichir l'affichage
							this.reloadGroupementParcs();
	
							// afficher le confirmation de suppression
							window.alert("Le groupement de parc " + gp.code + " a été supprimé");
						}
					}
				)
			;
		}
	}
	
	onGroupementCreate() {
		this.reloadGroupementParcs();
	}
	
	onGroupementUpdate(){
		this.reloadGroupementParcs();		
	}
	
	private reloadGroupementParcs() {
		this.gpService.getAll().subscribe(
			(results: GroupementParc[]) => {

				this.data = results;
		
				// Mise a jour du dataSource
				this.dataSource.data = this.data;
		
				// Retrait de l'indicateur de chargement
				this.isLoading = false;
			}
		);
	}
	
}